module.exports = {"340404001":"谢家集街道","340404002":"蔡家岗街道","340404003":"立新街道","340404004":"谢三村街道","340404005":"平山街道","340404100":"望峰岗镇","340404101":"李郢孜镇","340404102":"唐山镇","340404103":"杨公镇","340404200":"孙庙乡","340404201":"孤堆回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340404.json
// module id = 1175
// module chunks = 0